import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';
import { styled } from '@zoopla-eng/zds-components/themes';
import { StampDutyCalculator } from '@zoopla/stamp-duty-calculator';
import { FC } from 'react';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '../../../../ContentfulRenderOptions';

const StampDutyWrapperInner = styled('div', {
    marginBottom: '$M100'
});

export const StampDutyWrapper: FC<
    React.PropsWithChildren<{ title: string; body: Document }>
> = ({ title, body }) => (
    <StampDutyWrapperInner>
        <StampDutyCalculator
            show={true}
            inputValue=""
            trackingCategory=""
            title={title}
            body={documentToReactComponents(body, CONTENTFUL_RICH_TEXT_OPTIONS)}
        />
    </StampDutyWrapperInner>
);
